import { render } from "./index.vue?vue&type=template&id=2b8d889c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2b8d889c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8d889c"],['__file',"src/views/order/list/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b8d889c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b8d889c', __exports__)) {
    console.log('reload')
    api.reload('2b8d889c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2b8d889c&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b8d889c', render)
  })

}


export default __exports__